<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class=" py-4  d-md-down-none card-login" style="width:40%">
              <b-card-body class="text-center">
                <div>
                  <img  class="navbar-brand-full d-none d-md-block pull-right"  src="img/ms_logo.png"
                       alt="MS">
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="submit">

                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      placeholder="Nova lozinka"
                      type="password"
                      class="form-control"
                      aria-describedby="inputUsernameFeedback"
                      v-model.trim="new_password">
                    </b-form-input>
                    <b-form-invalid-feedback id="inputUsernameFeedback">
                     Required field
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      placeholder="Ponovi lozinku"
                      type="password"
                      class="form-control"
                      autocomplete="current-password"
                      aria-describedby="inputPasswordFeedback"
                      v-model="repeat_password">
                    </b-form-input>
                    <b-form-invalid-feedback id="inputPasswordFeedback">
                      Required field
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="danger" class="px-4">SAČUVAJ
                      </b-button>
                    </b-col>

                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
   <loading :show="showLoading" :label="label" :overlay="overlay"/>
  </div>
</template>

<script>
  import {getUserWithMagicLink} from '@/services/user/index'
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import routeName from '@/router/routeNames'
  import loading from 'vue-full-loading'
  import {INSTITUTION_VIEW_USER,INSTITUTION_USER} from "@/shared/constants";

  export default {
        name: "PasswordReset",
        data(){
          return {
            showLoading:false,
            label: 'Loading...',
            overlay: true,
            new_password:null,
            repeat_password:null,
            button_loading:false,
            user:{
              id:null,
              email:null
            },
            type: null

        }
        },
      mixins:[getErrorMessage],
      components:{AppButtonSubmit,loading},
      methods: {

        submit() {

          if(this.new_password != this.repeat_password) {
            this.new_password = null
            this.repeat_password = null
            toast({
              'title': this.$t('PASSWORD_DO_NOT_MATCH'),
              'message': null,
              'type': 'error',
              'timeout': 6000
            })
            return
          }
          this.showLoading = true
          this.$store.dispatch('auth/actionEnableUser', {id: this.user.id, password: this.new_password, type: this.type}).then(() => {
            this.$store.dispatch('user/actionSetUser').then(userResponse => {
              this.$store.dispatch('user/actionSetUserPermissions').then(()=>{
                toast({
                  title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                  message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                  type: 'success',
                  timeout: 3000
                })
              }).finally(()=>{
                this.$router.replace({name: routeName.RN_HOME})
                this.showLoading = false
              })
            }, error=>{
              this.showLoading = false
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                type: 'error',
                timeout: 6000
              })
            })
          })
        },
        async getUserByToken(token, type) {
        this.showLoading = true
        await  getUserWithMagicLink(token, {type}).then(response => {
          this.user = response.data
        }, error=>{
          this.goTo404()
          toast({
            title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
            message: this.$t('NOTIFICATIONS.ERROR_MESSAGE', {value: this.getMessages(error)}),
            type: 'error',
            timeout: 6000
          })
        }).finally(()=>{
          this.showLoading = false
        })
        },

        goTo404() {
         return this.$router.replace({name: routeName.RN_LOGIN})
        }
      },
      watch:{
        '$route.query': {
          async handler(query) {
            console.log(query, 'query')
            if (query.token) {
              await this.getUserByToken(query.token, query.type)
            } else {
              this.goTo404()
            }

          },
          immediate: true
        }
      },

    }
</script>

<style>
.card-login{
  background: #fdfdfd99;
}
</style>
